import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { DEVELOPER_AUTH_CONFIG, USER_AUTH_CONFIG } from "./config/aws-config";

const initialAuthConfig = window.location.pathname.startsWith("/developer/")
  ? DEVELOPER_AUTH_CONFIG
  : USER_AUTH_CONFIG;
Amplify.configure(initialAuthConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
